import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../../environments/environment";
import { Controle } from "../models/controle.model";
import {
  ControleNonApplicableDeclaration,
  DeclarationNonRealisablePayload,
  ReponseNonApplicablePayload,
} from "../models/controle-non-applicable.model";

/**
 * « Non applicable » en production (06/10/2026), les routes du contrat
 * (`docs/plan/non-applicable-production.md` § 7). Les refus (409 / 403 / 400) sont traduits par
 * l'intercepteur d'erreurs (`errors.CONTROLE.NA_*`) : aucun appelant n'affiche lui-même l'erreur.
 */
@Injectable({ providedIn: "root" })
export class ControleNonApplicableApiService {
  private http = inject(HttpClient);

  /** Une réponse « Non applicable » : TOUJOURS une instance neuve (jamais une réponse réécrite). */
  declarer(body: ReponseNonApplicablePayload): Observable<Controle> {
    return this.http.post<Controle>(`${environment.api()}/controle/non-applicable`, body);
  }

  /** Retire une réponse « Non applicable » (refusé si l'instance n'est pas NA, ou étape close). */
  annuler(id: string): Observable<{ id: string }> {
    return this.http.delete<{ id: string }>(`${environment.api()}/controle/non-applicable/${id}`);
  }

  /** « Contrôle non réalisable » : toutes les occurrences, à partir de maintenant (ou du début de l'étape). */
  declarerNonRealisable(body: DeclarationNonRealisablePayload): Observable<ControleNonApplicableDeclaration> {
    return this.http.post<ControleNonApplicableDeclaration>(`${environment.api()}/controle-non-applicable`, body);
  }

  /** Annuler une déclaration : `jusquA = maintenant` (la ligne reste, l'historique aussi). */
  annulerNonRealisable(id: string): Observable<ControleNonApplicableDeclaration> {
    return this.http.post<ControleNonApplicableDeclaration>(`${environment.api()}/controle-non-applicable/${id}/annuler`, null);
  }

  /**
   * Toutes les déclarations de l'étape (actives et closes). Lecture SILENCIEUSE : la frise la relit en
   * fond, une erreur ne doit pas lever de message (elle garde ce qu'elle avait).
   */
  declarationsDeLEtape(peoId: string): Observable<ControleNonApplicableDeclaration[]> {
    return this.http.get<ControleNonApplicableDeclaration[]>(`${environment.api()}/controle-non-applicable/peo/${peoId}`, {
      headers: { "skip-error-interceptor": "true" },
    });
  }
}
